@if (exam != null) {
  <div class="row border-bottom mt-3 pb-3">
    <div class="col col-12 col-xl-3 col-lg-2"><b>{{exam.courseName}} ({{exam.languageName }})</b></div>
    <div class="col col-12 col-lg-3">Opens: {{exam.openingDateTime | date:'MMMM d, y, h:mm a' }} UK time<br>
    Closes: {{exam.closingDateTime | date:'MMMM d, y, h:mm a' }} UK time</div>
    <div class="col col-12 col-lg-3">
      <p>
        @if (isExaminationInProgress(exam)) {
          <b class="available">Assessment is open </b>
        }
        @if (!isExaminationInProgress(exam) && !isExaminationClosed(exam)) {
          <i class="upcoming">Assessment paper
          will be available here from {{exam.openingDateTime | date:'MMMM d, y, h:mm a' }} UK Time </i>
        }
        @if (isExaminationClosed(exam)) {
          <b class="unavailable">Assessment is closed </b>
        }
      </p>
    </div>
    <div class="col col-12 col-xl-3 col-lg-4">
      @if (isExaminationInProgress(exam)) {
        <a class="btn btn-primary wrapButtonText mb-2 mr-lg-0 mr-2" [href]="getExamPaperUrl(exam)"> Download
        assessment paper </a><span class="btn btn-primary wrapButtonText mb-2" (click)="showConsent(exam)">
      Submit your answers </span>
    }
  </div>
</div>
}
